import React from "react";
import { ChipButton } from "./SortingChips.styles";
import { SortItemType } from "./SortingChips.types";
import { SORT_CRITERIA_LIST } from "@shared/consts";

export function SortingChips({
    selectedIndex,
    onChange,
}: {
    onChange: (sortItem: SortItemType) => void;
    selectedIndex: number;
}) {
    return (
        <>
            {SORT_CRITERIA_LIST.map((sortItem, index) => (
                <ChipButton
                    key={index}
                    active={selectedIndex === index}
                    onClick={() => onChange(sortItem)}
                >
                    {sortItem.label}
                </ChipButton>
            ))}
        </>
    );
}
